import { render, staticRenderFns } from "./yxmarketing.vue?vue&type=template&id=bd8401a8&scoped=true&"
import script from "./yxmarketing.vue?vue&type=script&lang=js&"
export * from "./yxmarketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8401a8",
  null
  
)

export default component.exports